module.exports = __webpack_public_path__ + "static/img/story.9c89906.png";


//////////////////
// WEBPACK FOOTER
// ./public/image/story.png
// module id = 3ezG
// module chunks = 1